/**
 * Tarif Enterprise in der Konsole (0541, Befund S4): eigene Grenzen je Verbund an der Hauptagentur. Leer = Standard des Tarifs,
 * „unbegrenzt“ oder -1 = ohne Grenze, sonst eine ganze Zahl ab 0.
 */

export const ENTERPRISE_PLAN = "enterprise";

export const ENTERPRISE_GRENZEN: readonly { key: string; label: string; einheit: string }[] = [
  { key: "max_talents", label: "Creator", einheit: "" },
  { key: "max_seats", label: "Team-Plätze", einheit: "" },
  { key: "max_contracts_per_month", label: "Verträge im Monat", einheit: "" },
  { key: "storage_gb", label: "Speicher", einheit: "GB" },
  { key: "media_video_max", label: "Videos", einheit: "" },
  { key: "media_video_mb", label: "Größe je Video", einheit: "MB" },
];

export interface EnterpriseStand {
  billing_org_id: string;
  billing_org_name: string | null;
  is_billing: boolean;
  plan_key: string | null;
  enterprise: boolean;
  defaults: Record<string, number>;
  own: Record<string, number>;
  effective: Record<string, number>;
  usage?: Record<string, number>;
}

/** Eingabe einer Grenze: null = Standard des Tarifs, -1 = unbegrenzt, "fehler" = keine gültige Zahl */
export function grenzeAusEingabe(roh: string): number | null | "fehler" {
  const s = roh.trim().toLowerCase();
  if (s === "") return null;
  if (s === "unbegrenzt" || s === "-1" || s === "∞") return -1;
  if (!/^\d{1,7}$/.test(s)) return "fehler";
  return Number(s);
}

/** Anzeige einer Grenze */
export function grenzeText(v: number | null | undefined, einheit = ""): string {
  if (v === null || v === undefined) return "–";
  if (v < 0) return "unbegrenzt";
  return einheit ? `${v.toLocaleString("de-DE")} ${einheit}` : v.toLocaleString("de-DE");
}

/** Eingabefeld aus dem Stand: eigener Wert, sonst leer (dann gilt der Standard) */
export function eingabeAusStand(stand: Pick<EnterpriseStand, "own">, key: string): string {
  const v = stand.own[key];
  return v === undefined ? "" : v < 0 ? "unbegrenzt" : String(v);
}

/** Geänderte Grenzen gegenüber dem gespeicherten Stand; null entfernt den eigenen Wert */
export function geaenderteGrenzen(stand: Pick<EnterpriseStand, "own">, eingaben: Record<string, string>): { key: string; value: number | null }[] | { fehler: string } {
  const out: { key: string; value: number | null }[] = [];
  for (const g of ENTERPRISE_GRENZEN) {
    const v = grenzeAusEingabe(eingaben[g.key] ?? "");
    if (v === "fehler") return { fehler: `${g.label}: bitte eine ganze Zahl ab 0 oder „unbegrenzt“ eintragen.` };
    const bisher = stand.own[g.key] ?? null;
    if (v !== bisher) out.push({ key: g.key, value: v });
  }
  return out;
}

/** Grenzen für die Nutzungsanzeige: im Tarif Enterprise die wirksamen Grenzen des Verbunds */
export function mitEnterpriseGrenzen(limits: Record<string, number>, stand: Pick<EnterpriseStand, "enterprise" | "effective"> | null | undefined): Record<string, number> {
  return stand?.enterprise ? { ...limits, ...stand.effective } : limits;
}

/** Zusatz zur Tarifauswahl: Enterprise ist kein ausgelaufener Tarif, sondern nur per Vertrag */
export function tarifZusatz(p: { key: string; active: boolean }): string {
  if (p.key === ENTERPRISE_PLAN) return " · nur per Vertrag";
  return p.active ? "" : " · nicht mehr angeboten";
}
